import dayjs from "dayjs";

import { ADVANCED_SETTINGS_COMMON_INFO } from "./constants";

import { getTargetLabel } from "../../../utils";

const getJobDuration = (start_time, end_time) =>
  start_time && end_time
    ? dayjs.unix(end_time).from(dayjs.unix(start_time), true)
    : "Not available";

const getCommonDetails = (
  isBinaryModel,
  { job_settings: { segmented, target }, id, start_time, end_time }
) => ({
  section: "Details",
  info: [
    { field: "ID", value: id },
    {
      field: "Completed in",
      value: getJobDuration(start_time, end_time),
    },
    {
      field: "Target",
      value: getTargetLabel(target) ?? "Not available",
    },
    isBinaryModel && {
      field: "Segmented",
      value: segmented ? "Yes" : "No",
    },
  ].filter(Boolean),
});

const getBinaryDetails = ({ boosting }) => ({
  section: "Advanced Settings",
  info: [
    ...ADVANCED_SETTINGS_COMMON_INFO,
    {
      field: "Optimized",
      value: boosting ? "Yes" : "No",
    },
  ],
});

const getAccordionSections = jobDetails => {
  const isBinaryModel = jobDetails.job_type === "binary_model_build";
  const commonDetails = getCommonDetails(isBinaryModel, jobDetails);

  return isBinaryModel
    ? [commonDetails, getBinaryDetails(jobDetails.job_settings)]
    : [commonDetails];
};

export { getAccordionSections };
